export default "__VITE_ASSET__XMs57qIR__"